export class ManagementOperationsUnregisteredExecutorPostRequest {
  unregisteredExecutorName!: string

  constructor(unregisteredExecutorName: string) {
    this.unregisteredExecutorName = unregisteredExecutorName
  }
}
